import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { ZIndex } from 'constants/zIndex';

export const Hidden = styled.div`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  z-index: ${ZIndex.Hidden};
  top: -10000px;
  left: -10000px;
  font-size: 0;
  color: ${Color.White};
  background-color: ${Color.White};
`;
